export default __webpack_public_path__ + "static/media/marker-orange-red.43a4ca45.png";